import { CloseButton } from '@chakra-ui/react';

import { Alert, AlertDescription, AlertIcon, Text } from '@bonusly/design-system';

interface SpotlightCompletionToastProps {
	spotlightId: string;
	onClose: () => void;
}

export const SpotlightCompletionToast = ({ spotlightId, onClose }: SpotlightCompletionToastProps) => {
	const handleClick = (e: React.MouseEvent) => {
		// Don't navigate if clicking the close button
		if ((e.target as HTMLElement).closest('button')) {
			return;
		}
		window.open(`/spotlight/${spotlightId}`, '_blank');
		onClose();
	};

	const handleClose = (e: React.MouseEvent) => {
		e.stopPropagation();
		onClose();
	};

	return (
		<Alert status="success" borderRadius="md" boxShadow="md" cursor="pointer" onClick={handleClick} _hover={{ opacity: 0.9 }} position="relative">
			<AlertIcon />
			<AlertDescription flex={1}>
				<Text fontWeight="medium" mb={1}>
					Employee Spotlight ready!
				</Text>
				<Text fontSize="sm">Click to view.</Text>
			</AlertDescription>
			<CloseButton onClick={handleClose} position="absolute" right={2} top={2} zIndex={1} />
		</Alert>
	);
};
